import React, { useState } from 'react';
import { useLocation } from 'hooks/router';
import { Table, Badge } from 'react-bootstrap';
import SoftwareUpdateService from 'services/softwareUpdateService';
import SoftwareUpdateHelper from 'components/navigation/softwareUpdate/softwareUpdateHelper';
import useAsyncEffect from 'use-async-effect';
import { last, find } from 'lodash';
import { Redirect } from 'react-router-dom';
import './softwareUpdateManifestPage.css';

const styles = {
  rowDiv: {
    lineHeight: '40px'
  },
  versionsDiv: {
    float: 'right',
    maxHeight: '48px'
  },
  installedVersionHolder: {
    lineHeight: 'unset'
  },
  newVersionHolder: {
    cursor: 'pointer',
    lineHeight: 'unset'
  },
  downArrow: {
    marginLeft: '3px'
  },
  installedVersion: {
    float: 'right'
  },
  toVersionContainer: {
    float: 'right',
    lineHeight: '45px'
  },
  updateRow: {
    cursor: 'pointer'
  },
  softwareName: {}
};

export default function SoftwareUpdateManifestPage(props) {
  const location = useLocation();
  const id = props.match.params.id;

  const [redirectData, setRedirectData] = useState(false);
  const [softwareTypeVersionsMap, setSoftwareTypeVersionsMap] = useState();
  const [softwareTypes, setSoftwareTypes] = useState([]);
  const [manifestData, setManifestData] = useState(null);

  useAsyncEffect(async () => {
    setSoftwareTypes(await SoftwareUpdateHelper.getSoftwareTypes());
    setSoftwareTypeVersionsMap(await SoftwareUpdateHelper.getSoftwareVersions());
  }, []);

  useAsyncEffect(async () => {
    setManifestData(null);
    const data = await SoftwareUpdateService.API.getSoftwareUpdateManifestById(id);
    setManifestData(data);
  }, [location]);

  const onCancel = () => {
    props.history.goBack();
  };

  const InstallNewUpdate = (softwareTypeId) => {
    setRedirectData({ versionId: last(softwareTypeVersionsMap[softwareTypeId]).id, softwareTypeId: softwareTypeId, siteId: id });
  };

  const renderInstallNewVersion = ({ softwareTypeId, installedVersion }) => {
    if (!softwareTypeVersionsMap[softwareTypeId]) return null;
    if (installedVersion === last(softwareTypeVersionsMap[softwareTypeId]).name) {
      return null;
    }
    return (
      <div style={styles.newVersionHolder}>
        <Badge variant='secondary' style={styles.newVersion} onClick={() => InstallNewUpdate(softwareTypeId)}>
          {last(softwareTypeVersionsMap[softwareTypeId]).name}
          <i className='icons8-chevron-down' style={styles.downArrow} />
        </Badge>
      </div>
    );
  };

  const renderAvailableSoftware = () => {
    const items = softwareTypes.filter((type) => !find(manifestData.manifest, { softwareTypeId: type.id }));
    return items.map((item, index) => renderManifestRow({ index, softwareTypeName: item.name, softwareTypeId: item.id }));
  };

  const renderInstalledSoftware = () => {
    return manifestData.manifest
      .filter((item) => item.installedVersion)
      .map((item, index) => renderManifestRow({ index, installedVersion: item.installedVersion, softwareTypeName: item.softwareTypeName, softwareTypeId: item.softwareTypeId }));
  };

  const renderManifestRow = ({ index, installedVersion, softwareTypeName, softwareTypeId }) => (
    <tr key={index}>
      <td style={styles.rowDiv}>
        <div style={styles.versionsDiv}>
          <div style={styles.installedVersionHolder}>
            <Badge variant='success' style={styles.installedVersion}>
              {installedVersion}
            </Badge>
          </div>
          {renderInstallNewVersion({ softwareTypeId, installedVersion })}
        </div>
        <span style={styles.softwareName}>{softwareTypeName}</span>
        <br />
      </td>
    </tr>
  );

  const onUpdateClicked = (updateId) => {
    props.history.push('/SoftwareUpdate/' + updateId);
  };

  const renderUpdatesRows = () => {
    const { recentSoftwareUpdateList } = manifestData;

    return recentSoftwareUpdateList.map((update, index) => (
      <tr
        key={index}
        onClick={() => {
          onUpdateClicked(update.softwareUpdateId);
        }}
        style={styles.updateRow}
      >
        <td>
          <div style={styles.toVersionContainer}>
            <span>To version {update.softwareVersionName}</span>
          </div>
          {update.softwareName}
          <br />
          <span>{update.siteStatusName}</span>
          <div>
            <span className='text-danger'>{update.softwareUpdateDtlResult}</span>
          </div>
        </td>
      </tr>
    ));
  };

  if (!manifestData || !softwareTypeVersionsMap) {
    return null;
  }

  if (redirectData) {
    return (
      <Redirect
        to={{
          pathname: '/softwareUpdate/create',
          state: { from: redirectData }
        }}
        {...props}
      />
    );
  }

  return (
    <>
      <div className='container'>
        <h3>{manifestData.name}</h3>
        <div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Installed Software</th>
              </tr>
            </thead>
            <tbody>{renderInstalledSoftware()}</tbody>
          </Table>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Available Software</th>
              </tr>
            </thead>
            <tbody>{renderAvailableSoftware()}</tbody>
          </Table>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Recent Updates</th>
              </tr>
            </thead>
            <tbody>{renderUpdatesRows()}</tbody>
          </Table>
        </div>
      </div>
    </>
  );
}
